export default __webpack_public_path__ + "static/media/home-seo-agency-img-02.29fcf768.jpg";